var render = function render(){var _vm=this,_c=_vm._self._c;return _c('report-tab',{ref:"reportTab",attrs:{"search-query":_vm.searchQuery,"date-range":_vm.dateRangeFromSingleDate,"selected-status":_vm.selectedStatus,"selected-delivery-type":_vm.selectedDeliveryType,"is-active-tab":_vm.isActiveTab}})
}
var staticRenderFns = []

export { render, staticRenderFns }